import React from "react";
import { Snackbar } from "@mui/material";

const CustomSnackbar = React.forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    isOpenSnack: ({ snackMessage }) => {
      setMessage(snackMessage);
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return <Snackbar open={open} onClose={handleClose} message={message} />;
});

export default CustomSnackbar;
